import { render, staticRenderFns } from "./MealsButtonWeek.vue?vue&type=template&id=a8c63d8c&scoped=true&"
import script from "./MealsButtonWeek.vue?vue&type=script&lang=js&"
export * from "./MealsButtonWeek.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8c63d8c",
  null
  
)

export default component.exports